/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type WorkloadDeviceRegistration = {
  /**
   * The agent the device inherits its policy from.
   */
  agentId: string;
  /**
   * The device's workload subject, device:<uuid>. Its assertions carry this as sub.
   */
  deviceSubject: string;
  /**
   * The issuer its assertions carry as iss.
   */
  issuer: string;
  /**
   * The organization the device enrolled in.
   */
  organizationId: string;
};

/** @internal */
export const WorkloadDeviceRegistration$inboundSchema: z.ZodMiniType<
  WorkloadDeviceRegistration,
  unknown
> = z.pipe(
  z.object({
    agent_id: z.string(),
    device_subject: z.string(),
    issuer: z.string(),
    organization_id: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "agent_id": "agentId",
      "device_subject": "deviceSubject",
      "organization_id": "organizationId",
    });
  }),
);

export function workloadDeviceRegistrationFromJSON(
  jsonString: string,
): SafeParseResult<WorkloadDeviceRegistration, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => WorkloadDeviceRegistration$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'WorkloadDeviceRegistration' from JSON`,
  );
}
